module.exports = __webpack_public_path__ + "static/commutersBannerIcon-133a2627bc8f2d3853dcf81eedbf5473.svg";